// ** Third Party Components
import {Delete, Download, Edit, Trash} from 'react-feather'
import {Input} from "reactstrap";
import React from "react";

// ** Table Common Column
export const columns= (toggleModal, toggleModalDelete) => [
  {
    name: 'No.',
    width: '20%',
    center: true,
    selector: row => row.noUser,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.noUser}
      </div>
    )
  },
  {
    name: 'Nombre Usuario',
    width: '13%',
    center: true,
    selector: row => row.userName,
    sortable: true,
    cell: row => (
        <div className='d-flex align-items-center text-center'>
          {row.userName}
        </div>
    )
  },
  {
    name: 'Activo',
    width: '12%',
    center: true,
    selector: row => row?.isActive,
    sortable: true,
    cell: row => (
        <div className='d-flex align-items-center text-center'>
          <Input className={'cursor-pointer'}
                 type='checkbox' defaultChecked={row?.isActive} disabled/>
        </div>
    )
  },
  {
    name: 'Area',
    width: '15%',
    sortable: true,
    center: true,
    selector: row => row.areas.map(area => area.name).join(",")
  },
  {
    name: 'Fecha de Creacion',
    width: '20%',
    center: true,
    sortable: true,
    selector: row => row.createDate,
  },
  {
    name: 'Rol',
    width: '10%',
    center: true,
    sortable: true,
    selector: row => row.role,
  },
  {
    name: 'Acciones',
    width: '10%',
    center: true,
    allowOverflow: true,
    cell: (row) => {
      return (
          <div className='d-flex'>
            <div className='pe-1 cursor-pointer text-primary'>
              <Edit onClick={() => toggleModal(true, row)} size={20} />
            </div>
            <div className='cursor-pointer text-danger'>
              <Trash onClick={() => toggleModalDelete(true, row)} size={20} />
            </div>
          </div>
      )
    }
  },
]
